import { ApolloProvider } from '@apollo/client'
import apolloClient from '@packages/services/src/apolloClient'
import React from 'react'
import ReactDOM from 'react-dom'
import { FlagsProvider } from './services/tog'
import Simulator from './Simulator'


ReactDOM.render(
  <ApolloProvider client={apolloClient}>
    <React.StrictMode>
      <FlagsProvider>
        <Simulator />
      </FlagsProvider>
    </React.StrictMode>
  </ApolloProvider>, document.getElementById('root')
)

